import { render, staticRenderFns } from "./detailPreview2.vue?vue&type=template&id=4a707c7c&scoped=true"
import script from "./detailPreview2.vue?vue&type=script&lang=js"
export * from "./detailPreview2.vue?vue&type=script&lang=js"
import style0 from "./detailPreview2.vue?vue&type=style&index=0&id=4a707c7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a707c7c",
  null
  
)

export default component.exports